module.exports = __webpack_public_path__ + "img/introduction_size_four@2x.b4fd172a.png";